import React from 'react';
import { Card, Box, Stack, Typography, Divider } from '@mui/material';
import { TicketSummaryData } from '../../@types/transactions';

type TicketSummaryProps = {
  summary: TicketSummaryData;
};

const SummaryItem = ({ label, value }: { label: string; value: string }) => (
  <Stack spacing={0.5}>
    <Typography variant="overline" sx={{ color: 'text.secondary' }}>
      {label}
    </Typography>
    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
      {value || 'N/A'}
    </Typography>
  </Stack>
);

const TicketSummary: React.FC<TicketSummaryProps> = ({ summary }) => (
  <Card sx={{ p: 3, mb: 3 }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'flex-start', md: 'center' },
        gap: { xs: 2, md: 0 }
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <SummaryItem label="Ticket Number" value={summary.ticketNumber} />
      </Box>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ display: { xs: 'none', md: 'block' }, mx: 1, borderColor: 'divider' }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <SummaryItem label="Date" value={summary.date} />
      </Box>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ display: { xs: 'none', md: 'block' }, mx: 1, borderColor: 'divider' }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <SummaryItem label="Net Weight" value={summary.netWeight} />
      </Box>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ display: { xs: 'none', md: 'block' }, mx: 1, borderColor: 'divider' }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <SummaryItem label="Driver" value={summary.driver} />
      </Box>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ display: { xs: 'none', md: 'block' }, mx: 1, borderColor: 'divider' }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <SummaryItem label="Vehicle" value={summary.vehicle} />
      </Box>
    </Box>
  </Card>
);

export default TicketSummary;
